// src/components/sidebar/Sidebar.js
import React, { memo } from "react";
import { CheckCircle, XCircle, Loader } from "lucide-react";
import DynamicIcon from "./DynamicIcon";
import "./Sidebar.css";

const Sidebar = memo(function Sidebar({
  isOpen,
  theme,
  sidebar_options,
  activeSidebarKey,
  onItemClick,
  reportStatus = {},
  reportStatusLoading = false,
}) {
  return (
    <aside className={`sidebar ${!isOpen ? "sidebar--closed" : ""}`}>
      <nav className="sidebar__nav">
        {sidebar_options &&
          Object.entries(sidebar_options).map(
            ([sectionKey, section], index, arr) => (
              <div key={sectionKey} className="sidebar__section">

                {/* ─── NEW: Section Title ─── */}
                <h3 className="sidebar__section-title">
                  {section.label || section.name || sectionKey}
                </h3>

                <ul className="sidebar__list">
                  {section.items.map((item) => {
                    const isActive = activeSidebarKey === item.key;
                    const isReport = item.type === "report";
                    const hasReport = reportStatus[item.key];
                    const statusKnown = item.key in reportStatus;

                    return (
                      <li key={item.key} className="sidebar__item">
                        <button
                          className={`sidebar__link ${
                            isActive ? "sidebar__link--active" : ""
                          }`}
                          onClick={() => onItemClick(item.key)}
                        >
                          <div className="sidebar__link-left">
                            {item.icon && (
                              <span className="sidebar__link-icon">
                                <DynamicIcon name={item.icon} size={18} />
                              </span>
                            )}
                            <span className="sidebar__link-text">
                              {item.label}
                            </span>
                          </div>

                          {isReport && (
                            <span className="sidebar__link-status">
                              {reportStatusLoading ? (
                                <Loader
                                  size={12}
                                  className="sidebar__status-icon sidebar__status-icon--loading"
                                />
                              ) : statusKnown ? (
                                hasReport ? (
                                  <CheckCircle
                                    size={12}
                                    className="sidebar__status-icon sidebar__status-icon--uploaded"
                                  />
                                ) : (
                                  <XCircle
                                    size={12}
                                    className="sidebar__status-icon sidebar__status-icon--missing"
                                  />
                                )
                              ) : null}
                            </span>
                          )}
                        </button>
                      </li>
                    );
                  })}
                </ul>

                {index < arr.length - 1 && (
                  <div className="sidebar__divider" />
                )}
              </div>
            )
          )}
      </nav>
    </aside>
  );
});

export default Sidebar;